import React from "react";
import { IconsType } from "../../../libs/Utils/types";
import s from "./Delete.module.scss";
import clsx from "clsx";
function Delete({ height, width, fill }: IconsType) {
  return (
    <div className={clsx(!width && s.wrapper)}>
      <svg
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: width || "100%",
          height: height || "100%",
        }}
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          d="M13 3.15789H10V1.57895C10 1.16018 9.84196 0.758573 9.56066 0.462463C9.27936 0.166353 8.89782 0 8.5 0H5.5C5.10218 0 4.72064 0.166353 4.43934 0.462463C4.15804 0.758573 4 1.16018 4 1.57895V3.15789H1C0.801088 3.15789 0.610322 3.24107 0.46967 3.38913C0.329018 3.53718 0.25 3.73799 0.25 3.94737C0.25 4.15675 0.329018 4.35756 0.46967 4.50561C0.610322 4.65367 0.801088 4.73684 1 4.73684H1.75V13.4211C1.75 13.8398 1.90804 14.2414 2.18934 14.5375C2.47064 14.8336 2.85218 15 3.25 15H10.75C11.1478 15 11.5294 14.8336 11.8107 14.5375C12.092 14.2414 12.25 13.8398 12.25 13.4211V4.73684H13C13.1989 4.73684 13.3897 4.65367 13.5303 4.50561C13.671 4.35756 13.75 4.15675 13.75 3.94737C13.75 3.73799 13.671 3.53718 13.5303 3.38913C13.3897 3.24107 13.1989 3.15789 13 3.15789ZM5.5 1.57895H8.5V3.15789H5.5V1.57895ZM6.25 11.8421C6.25 12.0515 6.17098 12.2523 6.03033 12.4003C5.88968 12.5484 5.69891 12.6316 5.5 12.6316C5.30109 12.6316 5.11032 12.5484 4.96967 12.4003C4.82902 12.2523 4.75 12.0515 4.75 11.8421V6.31579C4.75 6.10641 4.82902 5.9056 4.96967 5.75755C5.11032 5.60949 5.30109 5.52632 5.5 5.52632C5.69891 5.52632 5.88968 5.60949 6.03033 5.75755C6.17098 5.9056 6.25 6.10641 6.25 6.31579V11.8421ZM9.25 11.8421C9.25 12.0515 9.17098 12.2523 9.03033 12.4003C8.88968 12.5484 8.69891 12.6316 8.5 12.6316C8.30109 12.6316 8.11032 12.5484 7.96967 12.4003C7.82902 12.2523 7.75 12.0515 7.75 11.8421V6.31579C7.75 6.10641 7.82902 5.9056 7.96967 5.75755C8.11032 5.60949 8.30109 5.52632 8.5 5.52632C8.69891 5.52632 8.88968 5.60949 9.03033 5.75755C9.17098 5.9056 9.25 6.10641 9.25 6.31579V11.8421Z"
          fill={fill || "#240806"}
        />
      </svg>
    </div>
  );
}

export default Delete;
